<template>
	<div
		class="vdpComponent listing-search-input-container"
		v-bind:class="{vdpWithInput: hasInputElement, 'border-gray300': focused, 'border-green500': inputValue}"
	>
			<input
				v-bind="inputAttributes"
				class="listing-search-input"
			v-if="hasInputElement"
			type="text"
			:placeholder="placeholder"
			v-bind:readonly="isReadOnly"
			v-bind:value="inputValue"
			v-on:input="editable && processUserInput($event.target.value)"
			v-on:focus="editable && open()"
			v-on:click="editable && open()"
		/>
		<button
			v-if="editable && hasInputElement && inputValue"
			class="vdpClearInput"
			type="button"
      aria-label="Clear"
			v-on:click="clear"
		></button>
		<div class="vdpCalendarIcon flex items-center cursor-pointer" v-else v-on:click="opened ? close() : editable && open()">
			<svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M0 0H17V16H0V0Z" fill="white"/>
				<path fill-rule="evenodd" clip-rule="evenodd" d="M5 0C5.55228 0 6 0.447715 6 1V2H11V1C11 0.447715 11.4477 0 12 0C12.5523 0 13 0.447715 13 1V2H16C16.5523 2 17 2.44772 17 3V15C17 15.5523 16.5523 16 16 16H1C0.447715 16 0 15.5523 0 15V3C0 2.44772 0.447715 2 1 2H4V1C4 0.447715 4.44772 0 5 0ZM11 4V5C11 5.55228 11.4477 6 12 6C12.5523 6 13 5.55228 13 5V4H15V14H2V4H4V5C4 5.55228 4.44772 6 5 6C5.55228 6 6 5.55228 6 5V4H11ZM3.5 8C3.22386 8 3 8.22386 3 8.5V9.5C3 9.77614 3.22386 10 3.5 10H4.5C4.77614 10 5 9.77614 5 9.5V8.5C5 8.22386 4.77614 8 4.5 8H3.5ZM3 11.5C3 11.2239 3.22386 11 3.5 11H4.5C4.77614 11 5 11.2239 5 11.5V12.5C5 12.7761 4.77614 13 4.5 13H3.5C3.22386 13 3 12.7761 3 12.5V11.5ZM6.5 8C6.22386 8 6 8.22386 6 8.5V9.5C6 9.77614 6.22386 10 6.5 10H7.5C7.77614 10 8 9.77614 8 9.5V8.5C8 8.22386 7.77614 8 7.5 8H6.5ZM6 11.5C6 11.2239 6.22386 11 6.5 11H7.5C7.77614 11 8 11.2239 8 11.5V12.5C8 12.7761 7.77614 13 7.5 13H6.5C6.22386 13 6 12.7761 6 12.5V11.5ZM9.5 8C9.22386 8 9 8.22386 9 8.5V9.5C9 9.77614 9.22386 10 9.5 10H10.5C10.7761 10 11 9.77614 11 9.5V8.5C11 8.22386 10.7761 8 10.5 8H9.5ZM12 8.5C12 8.22386 12.2239 8 12.5 8H13.5C13.7761 8 14 8.22386 14 8.5V9.5C14 9.77614 13.7761 10 13.5 10H12.5C12.2239 10 12 9.77614 12 9.5V8.5ZM9.5 11C9.22386 11 9 11.2239 9 11.5V12.5C9 12.7761 9.22386 13 9.5 13H10.5C10.7761 13 11 12.7761 11 12.5V11.5C11 11.2239 10.7761 11 10.5 11H9.5ZM12 11.5C12 11.2239 12.2239 11 12.5 11H13.5C13.7761 11 14 11.2239 14 11.5V12.5C14 12.7761 13.7761 13 13.5 13H12.5C12.2239 13 12 12.7761 12 12.5V11.5Z" fill="#ADB4B8"/>
			</svg>
		</div>

		<transition name="vdp-toggle-calendar">
			<div
				v-if="opened"
				class="vdpOuterWrap"
				ref="outerWrap"
				v-on:click="closeViaOverlay"
				v-bind:class="[positionClass, {vdpFloating: hasInputElement}]"
			>
				<div class="vdpInnerWrap">
					<header class="vdpHeader">
						<button
							class="vdpArrow vdpArrowPrev"
							v-bind:title="prevMonthCaption"
							type="button"
							v-on:click="incrementMonth(-1)"
						>{{ prevMonthCaption }}</button>
						<button
							class="vdpArrow vdpArrowNext"
							type="button"
							v-bind:title="nextMonthCaption"
							v-on:click="incrementMonth(1)"
						>{{ nextMonthCaption }}</button>
						<div class="vdpPeriodControls">
							<div class="vdpPeriodControl">
								<button
									v-bind:class="directionClass"
									v-bind:key="currentPeriod.month"
									type="button"
								>{{ months[currentPeriod.month] }}</button>
								<select v-model="currentPeriod.month">
									<option
										v-for="(month, index) in months"
										v-bind:value="index"
										v-bind:key="month"
									>{{ month }}</option>
								</select>
							</div>
							<div class="vdpPeriodControl">
								<button
									v-bind:class="directionClass"
									v-bind:key="currentPeriod.year"
									type="button"
								>{{ currentPeriod.year }}</button>
								<select v-model="currentPeriod.year">
									<option v-for="year in yearRange" v-bind:value="year" v-bind:key="year">{{ year }}</option>
								</select>
							</div>
						</div>
					</header>
					<table class="vdpTable">
						<thead>
							<tr>
								<th class="vdpHeadCell" v-for="weekday in weekdaysSorted" v-bind:key="weekday">
									<span class="vdpHeadCellContent">{{weekday}}</span>
								</th>
							</tr>
						</thead>
						<tbody
							v-bind:key="currentPeriod.year + '-' + currentPeriod.month"
							v-bind:class="directionClass"
						>
							<tr class="vdpRow" v-for="(week, weekIndex) in currentPeriodDates" v-bind:key="weekIndex">
								<td
									class="vdpCell"
									v-for="item in week"
									v-bind:class="{
                                        selectable: !item.disabled,
                                        selected: item.selected,
                                        disabled: item.disabled,
                                        today: item.today,
                                        outOfRange: item.outOfRange
                                    }"
									v-bind:data-id="item.dateKey"
									v-bind:key="item.dateKey"
									v-on:click="selectDateItem(item)"
								>
									<div class="vdpCellContent">{{ item.date.getDate() }}</div>
								</td>
							</tr>
						</tbody>
					</table>
					<div v-if="pickTime && currentTime" class="vdpTimeControls">
						<span class="vdpTimeCaption">{{ setTimeCaption }}</span>
						<div class="vdpTimeUnit">
							<pre><span>{{ currentTime.hoursPadded }}</span><br /></pre>
							<input
								type="number"
								pattern="\d*"
								class="vdpHoursInput"
								v-on:input.prevent="inputTime('setHours', $event)"
								v-bind:value="currentTime.hoursPadded"
							/>
						</div>
						<span v-if="pickMinutes" class="vdpTimeSeparator">:</span>
						<div v-if="pickMinutes" class="vdpTimeUnit">
							<pre><span>{{ currentTime.minutesPadded }}</span><br /></pre>
							<input
								v-if="pickMinutes"
								type="number"
								pattern="\d*"
								class="vdpMinutesInput"
								v-on:input="inputTime('setMinutes', $event)"
								v-bind:value="currentTime.minutesPadded"
							/>
						</div>
						<span v-if="pickSeconds" class="vdpTimeSeparator">:</span>
						<div v-if="pickSeconds" class="vdpTimeUnit">
							<pre><span>{{ currentTime.secondsPadded }}</span><br /></pre>
							<input
								v-if="pickSeconds"
								type="number"
								pattern="\d*"
								class="vdpSecondsInput"
								v-on:input="inputTime('setSeconds', $event)"
								v-bind:value="currentTime.secondsPadded"
							/>
						</div>
					</div>
				</div>
			</div>
		</transition>
	</div>
</template>

<script>
	const formatRE = /,|\.|-| |:|\/|\\/;
	const dayRE = /D+/;
	const monthRE = /M+/;
	const yearRE = /Y+/;
	const hoursRE = /h+/i;
	const minutesRE = /m+/;
	const secondsRE = /s+/;

	// Vue 3 date input used by sales-database closed-date filters.
	export default {
		props: {
			modelValue: { type: String, default: "" },
			placeholder: { type: String, default: "" },
			format: { type: String, default: "YYYY-MM-DD" },
			displayFormat: { type: String },
			editable: { type: Boolean, default: true },
			hasInputElement: { type: Boolean, default: true },
			inputAttributes: { type: Object },
			selectableYearRange: { type: Number, default: 40 },
			parseDate: { type: Function },
			formatDate: { type: Function },
			pickTime: { type: Boolean, default: false },
			pickMinutes: { type: Boolean, default: true },
			pickSeconds: { type: Boolean, default: false },
			isDateDisabled: { type: Function, default: () => false },
			nextMonthCaption: { type: String, default: "Next month" },
			prevMonthCaption: { type: String, default: "Previous month" },
			setTimeCaption: { type: String, default: "Set time:" },
			mobileBreakpointWidth: { type: Number, default: 500 },
			weekdays: {
				type: Array,
				default: () => ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"]
			},
			months: {
				type: Array,
				default: () => [
					"January",
					"February",
					"March",
					"April",
					"May",
					"June",
					"July",
					"August",
					"September",
					"October",
					"November",
					"December"
				]
			},
			startWeekOnSunday: { type: Boolean, default: false }
		},
		emits: ['update:modelValue'],

		data() {
			return {
				inputValue: this.valueToInputFormat(this.modelValue),
				currentPeriod: this.getPeriodFromValue(this.modelValue, this.format),
				direction: undefined,
				positionClass: undefined,
				opened: !this.hasInputElement,
				focused: false,
				inputted: false
			};
		},

		computed: {
			valueDate() {
				const value = this.modelValue;
				const format = this.format;

				return value ? this.parseDateString(value, format) : undefined;
			},

			isReadOnly() {
				return (
					!this.editable ||
					(this.inputAttributes && this.inputAttributes.readonly)
				);
			},

			isValidValue() {
				const valueDate = this.valueDate;

				return this.modelValue ? Boolean(valueDate) : true;
			},

			currentPeriodDates() {
				const { year, month } = this.currentPeriod;
				const days = [];
				const date = new Date(year, month, 1);
				const today = new Date();
				const offset = this.startWeekOnSunday ? 1 : 0;

				// append prev month dates
				const startDay = date.getDay() || 7;

				if (startDay > 1 - offset) {
					for (let i = startDay - (2 - offset); i >= 0; i--) {
						const prevDate = new Date(date);
						prevDate.setDate(-i);
						days.push({ outOfRange: true, date: prevDate });
					}
				}

				while (date.getMonth() === month) {
					days.push({ date: new Date(date) });
					date.setDate(date.getDate() + 1);
				}

				// append next month dates
				const daysLeft = 7 - (days.length % 7);

				for (let i = 1; i <= daysLeft; i++) {
					const nextDate = new Date(date);
					nextDate.setDate(i);
					days.push({ outOfRange: true, date: nextDate });
				}

				// define day states
				days.forEach(day => {
					day.disabled = this.isDateDisabled(day.date);
					day.today = areSameDates(day.date, today);
					day.dateKey = [
						day.date.getFullYear(),
						day.date.getMonth() + 1,
						day.date.getDate()
					].join("-");
					day.selected = this.valueDate
						? areSameDates(day.date, this.valueDate)
						: false;
				});

				return chunkArray(days, 7);
			},

			yearRange() {
				const years = [];
				const currentYear = this.currentPeriod.year;
				const startYear = currentYear - this.selectableYearRange;
				const endYear = currentYear + this.selectableYearRange;

				for (let i = startYear; i <= endYear; i++) {
					years.push(i);
				}

				return years;
			},

			currentTime() {
				const currentDate = this.valueDate;

				return currentDate
					? {
							hours: currentDate.getHours(),
							minutes: currentDate.getMinutes(),
							seconds: currentDate.getSeconds(),
							hoursPadded: paddNum(currentDate.getHours(), 1),
							minutesPadded: paddNum(currentDate.getMinutes(), 2),
							secondsPadded: paddNum(currentDate.getSeconds(), 2)
					  }
					: undefined;
			},

			directionClass() {
				return this.direction ? `vdp${this.direction}Direction` : undefined;
			},

			weekdaysSorted() {
				if (this.startWeekOnSunday) {
					const weekdays = this.weekdays.slice();
					weekdays.unshift(weekdays.pop());
					return weekdays;
				} else {
					return this.weekdays;
				}
			}
		},

		watch: {
			modelValue(value) {
				if (this.isValidValue) {
					this.inputValue = this.valueToInputFormat(value);
					this.currentPeriod = this.getPeriodFromValue(
						value,
						this.format
					);
				}
			},

			"currentPeriod.month"(month, oldMonth) {
				if (month !== oldMonth) this.direction = month > oldMonth ? "Next" : "Prev";
			},

			"currentPeriod.year"(year, oldYear) {
				if (year !== oldYear) this.direction = year > oldYear ? "Next" : "Prev";
			}
		},

		beforeUnmount() {
			this.removeCloseEvents();
			this.teardownPosition();
		},

		methods: {
			valueToInputFormat(value) {
				return !this.displayFormat
					? value
					: this.formatDateToString(
							this.parseDateString(value, this.format),
							this.displayFormat
					  ) || value;
			},

			getPeriodFromValue(dateString, format) {
				const date = this.parseDateString(dateString, format) || new Date();

				return { month: date.getMonth(), year: date.getFullYear() };
			},

			parseDateString(dateString, dateFormat) {
				return !dateString
					? undefined
					: this.parseDate
					? this.parseDate(dateString, dateFormat)
					: this.parseSimpleDateString(dateString, dateFormat);
			},

			formatDateToString(date, dateFormat) {
				return !date
					? ""
					: this.formatDate
					? this.formatDate(date, dateFormat)
					: this.formatSimpleDateToString(date, dateFormat);
			},

			parseSimpleDateString(dateString, dateFormat) {
				let day, month, year, hours, minutes, seconds;

				const dateParts = dateString.split(formatRE);
				const formatParts = dateFormat.split(formatRE);
				const partsSize = formatParts.length;

				for (let i = 0; i < partsSize; i++) {
					if (formatParts[i].match(dayRE)) {
						day = parseInt(dateParts[i], 10);
					} else if (formatParts[i].match(monthRE)) {
						month = parseInt(dateParts[i], 10);
					} else if (formatParts[i].match(yearRE)) {
						year = parseInt(dateParts[i], 10);
					} else if (formatParts[i].match(hoursRE)) {
						hours = parseInt(dateParts[i], 10);
					} else if (formatParts[i].match(minutesRE)) {
						minutes = parseInt(dateParts[i], 10);
					} else if (formatParts[i].match(secondsRE)) {
						seconds = parseInt(dateParts[i], 10);
					}
				}

				const resolvedDate = new Date(
					[paddNum(year, 4), paddNum(month, 2), paddNum(day, 2)].join("-")
				);

				if (isNaN(resolvedDate)) {
					return undefined;
				} else {
					const date = new Date(year, month - 1, day);

					[
						[year, "setFullYear"],
						[hours, "setHours"],
						[minutes, "setMinutes"],
						[seconds, "setSeconds"]
					].forEach(([value, method]) => {
						typeof value !== "undefined" && date[method](value);
					});

					return date;
				}
			},

			formatSimpleDateToString(date, dateFormat) {
				return dateFormat
					.replace(yearRE, match => date.getFullYear())
					.replace(monthRE, match =>
						paddNum(date.getMonth() + 1, match.length)
					)
					.replace(dayRE, match => paddNum(date.getDate(), match.length))
					.replace(hoursRE, match =>
						paddNum(date.getHours(), match.length)
					)
					.replace(minutesRE, match =>
						paddNum(date.getMinutes(), match.length)
					)
					.replace(secondsRE, match =>
						paddNum(date.getSeconds(), match.length)
					);
			},

			incrementMonth(increment = 1) {
				const refDate = new Date(
					this.currentPeriod.year,
					this.currentPeriod.month
				);
				const incrementDate = new Date(
					refDate.getFullYear(),
					refDate.getMonth() + increment
				);

				this.currentPeriod = {
					month: incrementDate.getMonth(),
					year: incrementDate.getFullYear()
				};
			},

			processUserInput(userText) {
				const userDate = this.parseDateString(
					userText,
					this.displayFormat || this.format
				);

				this.inputValue = userText;

				this.$emit(
					"update:modelValue",
					userDate
						? this.formatDateToString(userDate, this.format)
						: userText
				);
			},

			open() {
				if (!this.opened) {
					this.focused = true;
					this.opened = true;
					this.currentPeriod = this.getPeriodFromValue(
						this.modelValue,
						this.format
					);
					this.addCloseEvents();
					this.setupPosition();
				}
				this.direction = undefined;
			},

			close() {
				if (this.opened) {
					this.focused = false;
					this.opened = false;
					this.direction = undefined;
					this.removeCloseEvents();
					this.teardownPosition();
				}			
			},

			closeViaOverlay(e) {
				if (this.hasInputElement && e.target === this.$refs.outerWrap) {
					this.close();
				}
			},

			addCloseEvents() {
				if (!this.closeEventListener) {
					this.closeEventListener = e => this.inspectCloseEvent(e);

					const vm = this;
					var elements = document.getElementsByClassName("listing-filter-options");
					Array.from(elements).forEach(function(element) {
						element.addEventListener('click', vm.closeEventListener);
					});

					["click", "keyup", "focusin"].forEach(eventName =>
						document.addEventListener(
							eventName,
							this.closeEventListener
						)
					);
				}
			},

			inspectCloseEvent(event) {
				if (event.keyCode) {
					event.keyCode === 27 && this.close();
				} else if (
					!(event.target === this.$el) &&
					!this.$el.contains(event.target)
				) {
					this.close();
				}
			},

			removeCloseEvents() {
				if (this.closeEventListener) {
					const vm = this;
					var elements = document.getElementsByClassName("listing-filter-options");
					Array.from(elements).forEach(function(element) {
						element.removeEventListener('click', vm.closeEventListener);
					});

					["click", "keyup", "focusin"].forEach(eventName =>
						document.removeEventListener(
							eventName,
							this.closeEventListener
						)
					);

					delete this.closeEventListener;
				}
			},

			setupPosition() {
				if (!this.positionEventListener) {
					this.positionEventListener = () => this.positionFloater();
					window.addEventListener("resize", this.positionEventListener);
				}

				this.positionFloater();
			},

			positionFloater() {
				const inputRect = this.$el.getBoundingClientRect();

				let verticalClass = "vdpPositionTop";
				let horizontalClass = "vdpPositionLeft";

				const calculate = () => {
					const rect = this.$refs.outerWrap.getBoundingClientRect();
					const floaterHeight = rect.height;
					const floaterWidth = rect.width;

					if (window.innerWidth > this.mobileBreakpointWidth) {
						// vertical
						if (
							inputRect.top + inputRect.height + floaterHeight >
								window.innerHeight &&
							inputRect.top - floaterHeight > 0
						) {
							verticalClass = "vdpPositionBottom";
						}

						// horizontal
						if (inputRect.left + floaterWidth > window.innerWidth) {
							horizontalClass = "vdpPositionRight";
						}

						this.positionClass = [
							"vdpPositionReady",
							verticalClass,
							horizontalClass
						].join(" ");
					} else {
						this.positionClass = "vdpPositionFixed";
					}
				};

				this.$refs.outerWrap ? calculate() : this.$nextTick(calculate);
			},

			teardownPosition() {
				if (this.positionEventListener) {
					this.positionClass = undefined;
					window.removeEventListener(
						"resize",
						this.positionEventListener
					);
					delete this.positionEventListener;
				}
			},

			clear() {
				this.$emit("update:modelValue", "");
			},

			selectDateItem(item) {
				if (!item.disabled) {
					const newDate = new Date(item.date);

					if (this.currentTime) {
						newDate.setHours(this.currentTime.hours);
						newDate.setMinutes(this.currentTime.minutes);
						newDate.setSeconds(this.currentTime.seconds);
					}

					this.$emit(
						"update:modelValue",
						this.formatDateToString(newDate, this.format)
					);

					if (this.hasInputElement && !this.pickTime) {
						this.close();
					}
				}
			},

			inputTime(method, event) {
				const currentDate = this.valueDate;
				const maxValues = { setHours: 23, setMinutes: 59, setSeconds: 59 };

				let numValue = parseInt(event.target.value, 10) || 0;

				if (numValue > maxValues[method]) {
					numValue = maxValues[method];
				} else if (numValue < 0) {
					numValue = 0;
				}

				event.target.value = paddNum(
					numValue,
					method === "setHours" ? 1 : 2
				);
				currentDate[method](numValue);

				this.$emit(
					"update:modelValue",
					this.formatDateToString(currentDate, this.format)
				);
			}
		}
	};

	function paddNum(num, padsize) {
		return typeof num !== "undefined"
			? num.toString().length > padsize
				? num
				: new Array(padsize - num.toString().length + 1).join("0") + num
			: undefined;
	}

	function chunkArray(inputArray, chunkSize) {
		const results = [];

		while (inputArray.length) {
			results.push(inputArray.splice(0, chunkSize));
		}

		return results;
	}

	function areSameDates(date1, date2) {
		return (
			date1.getDate() === date2.getDate() &&
			date1.getMonth() === date2.getMonth() &&
			date1.getFullYear() === date2.getFullYear()
		);
	}
</script>

<style>
	@-webkit-keyframes a {
		0% {
			opacity: 0;
			-webkit-transform: translate3d(-0.5em, 0, 0);
			transform: translate3d(-0.5em, 0, 0);
		}
		to {
			opacity: 1;
			-webkit-transform: translateZ(0);
			transform: translateZ(0);
		}
	}

	@keyframes a {
		0% {
			opacity: 0;
			-webkit-transform: translate3d(-0.5em, 0, 0);
			transform: translate3d(-0.5em, 0, 0);
		}
		to {
			opacity: 1;
			-webkit-transform: translateZ(0);
			transform: translateZ(0);
		}
	}

	@-webkit-keyframes b {
		0% {
			opacity: 0;
			-webkit-transform: translate3d(0.5em, 0, 0);
			transform: translate3d(0.5em, 0, 0);
		}
		to {
			opacity: 1;
			-webkit-transform: translateZ(0);
			transform: translateZ(0);
		}
	}

	@keyframes b {
		0% {
			opacity: 0;
			-webkit-transform: translate3d(0.5em, 0, 0);
			transform: translate3d(0.5em, 0, 0);
		}
		to {
			opacity: 1;
			-webkit-transform: translateZ(0);
			transform: translateZ(0);
		}
	}

	@-webkit-keyframes c {
		0% {
			opacity: 0;
			-webkit-transform: scale(0.5);
			transform: scale(0.5);
		}
		to {
			opacity: 1;
			-webkit-transform: scale(1);
			transform: scale(1);
		}
	}

	@keyframes c {
		0% {
			opacity: 0;
			-webkit-transform: scale(0.5);
			transform: scale(0.5);
		}
		to {
			opacity: 1;
			-webkit-transform: scale(1);
			transform: scale(1);
		}
	}

	@-webkit-keyframes d {
		0% {
			opacity: 0;
		}
		to {
			opacity: 1;
		}
	}

	@keyframes d {
		0% {
			opacity: 0;
		}
		to {
			opacity: 1;
		}
	}

	.vdp-toggle-calendar-enter-active.vdpPositionReady {
		-webkit-transform-origin: top left;
		-ms-transform-origin: top left;
		transform-origin: top left;
		-webkit-animation: c 0.2s;
		animation: c 0.2s;
	}

	.vdp-toggle-calendar-leave-active {
		animation: c 0.15s reverse;
	}

	.vdp-toggle-calendar-enter-active.vdpPositionFixed {
		-webkit-animation: d 0.3s;
		animation: d 0.3s;
	}

	.vdp-toggle-calendar-leave-active.vdpPositionFixed {
		animation: d 0.3s reverse;
	}

	.vdpComponent {
		position: relative;
	}

	.vdpComponent.vdpWithInput > input {
		padding-right: 30px;
	}

	.vdpClearInput:before {
		display: flex;
		align-items: center;
		color: #adb4b8;
		font-family: 'Icons';
		font-style: normal;
		line-height: 1em;
		width: auto;
		font-variant: normal;
		text-transform: none;
		text-decoration: inherit;
		text-align: center;
		speak: none;
		font-size: 16px;
		content: '\e804';
		margin-bottom: 5px;
		font-weight: 900;
	}

	.vdpOuterWrap {
		font-size: 10px;
		color: #4c5e67;
		font-family: Ubuntu, sans-serif;
	}

	.vdpOuterWrap.vdpFloating {
		position: absolute;
		padding: 0.5em 0;
		z-index: 2;
	}

	.vdpOuterWrap.vdpPositionFixed {
		position: fixed;
		left: 0;
		top: 0;
		bottom: 0;
		right: 0;
		padding: 2em;
		display: -ms-flexbox;
		display: flex;
		-ms-flex-pack: center;
		justify-content: center;
		-ms-flex-align: center;
		align-items: center;
		background-color: rgba(0, 0, 0, 0.3);
	}

	.vdpFloating .vdpInnerWrap {
		max-width: 30em;
	}

	.vdpPositionFixed .vdpInnerWrap {
		max-width: 30em;
		margin: 0 auto;
		border: 0;
		-webkit-animation: c 0.3s;
		animation: c 0.3s;
	}

	.vdpFloating.vdpPositionTop {
		top: 100%;
	}

	.vdpFloating.vdpPositionBottom {
		bottom: 100%;
	}

	.vdpFloating.vdpPositionLeft {
		left: 0;
	}

	.vdpFloating.vdpPositionRight {
		right: 0;
	}

	.vdpPositionTop.vdpPositionLeft {
		-webkit-transform-origin: top left;
		-ms-transform-origin: top left;
		transform-origin: top left;
	}

	.vdpPositionTop.vdpPositionRight {
		-webkit-transform-origin: top right;
		-ms-transform-origin: top right;
		transform-origin: top right;
	}

	.vdpPositionBottom.vdpPositionLeft {
		-webkit-transform-origin: bottom left;
		-ms-transform-origin: bottom left;
		transform-origin: bottom left;
	}

	.vdpPositionBottom.vdpPositionRight {
		-webkit-transform-origin: bottom right;
		-ms-transform-origin: bottom right;
		transform-origin: bottom right;
	}

	.vdpInnerWrap {
		overflow: hidden;
		min-width: 28em;
		box-sizing: border-box;
		padding: 1em;
		background: #fff;
		box-shadow: 0 4px 20px rgba(51, 72, 82, .08);
		border-radius: 2px;
		/* border: 1px solid #dcdddf; */
	}

	.vdpHeader {
		position: relative;
		padding: 0 1em 2.5em;
		margin: -1em -1em -2.5em;
		text-align: center;
		background: #f4f2f2;
	}

	.vdpArrow,
	.vdpClearInput,
	.vdpPeriodControl > button {
		margin: 0;
		padding: 0;
		border: 0;
		cursor: pointer;
		background: none;
	}

	.vdpArrow::-moz-focus-inner,
	.vdpClearInput::-moz-focus-inner,
	.vdpPeriodControl > button::-moz-focus-inner {
		padding: 0;
		border: 0;
	}

	.vdpArrow {
		font-size: 1em;
		width: 5em;
		text-indent: -999em;
		overflow: hidden;
		position: absolute;
		top: 0;
		bottom: 2.5em;
		text-align: left;
	}

	.vdpArrow:before {
		content: "";
		width: 2.2em;
		height: 2.2em;
		position: absolute;
		left: 50%;
		top: 50%;
		margin: -1.1em 0 0 -1.1em;
		border-radius: 100%;
		transition: background-color 0.2s;
	}

	.vdpArrow:active,
	.vdpArrow:focus,
	.vdpArrow:hover {
		outline: 0;
	}

	.vdpArrow:focus:before,
	.vdpArrow:hover:before {
		background-color: #dcdddf;
	}

	.vdpArrow:active:before {
		background-color: #c4c8cb;
	}

	.vdpArrowNext:before {
		margin-left: -1.4em;
	}

	.vdpArrow:after {
		content: "";
		position: absolute;
		left: 50%;
		top: 50%;
		margin-top: -0.5em;
		width: 0;
		height: 0;
		border: 0.5em solid transparent;
	}

	.vdpArrowPrev {
		left: -0.3em;
	}

	.vdpArrowPrev:after {
		margin-left: -0.8em;
		border-right-color: #9d5549;
	}

	.vdpArrowNext {
		right: -0.6em;
	}

	.vdpArrowNext:after {
		margin-left: -0.5em;
		border-left-color: #9d5549;
	}

	.vdpPeriodControl {
		display: inline-block;
		position: relative;
	}

	.vdpPeriodControl > button {
		font-size: 1.75em;
		font-weight: 600;
		padding: 1em 0.4em;
		display: inline-block;
	}

	.vdpPeriodControl > select {
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		cursor: pointer;
		opacity: 0;
		font-size: 1.6em;
	}

	.vdpTable {
		width: 100%;
		table-layout: fixed;
		position: relative;
		z-index: 1;
	}

	.vdpNextDirection {
		-webkit-animation: b 0.5s;
		animation: b 0.5s;
	}

	.vdpPrevDirection {
		-webkit-animation: a 0.5s;
		animation: a 0.5s;
	}

	.vdpCell,
	.vdpHeadCell {
		text-align: center;
		box-sizing: border-box;
	}

	.vdpCell {
		padding: 0.5em 0;
	}

	.vdpHeadCell {
		padding: 0.3em 0.5em 1.8em;
	}

	.vdpHeadCellContent {
		font-size: 1.3em;
		font-weight: 400;
		color: #959fa4;
	}

	.vdpCellContent {
		font-size: 1.4em;
		display: block;
		margin: 0 auto;
		width: 1.857em;
		height: 1.857em;
		line-height: 1.857em;
		text-align: center;
		border-radius: 100%;
		transition: background 0.1s, color 0.1s;
	}

	.vdpCell.outOfRange {
		color: #c4c8cb;
	}

	.vdpCell.today {
		color: #9d5549;
	}

	.vdpCell.selected .vdpCellContent {
		color: #fff;
		background: #9d5549;
	}

	@media (hover: hover) {
		.vdpCell.selectable:hover .vdpCellContent {
			color: #fff;
			background: #9d5549;
		}
	}

	.vdpCell.selectable {
		cursor: pointer;
	}

	.vdpCell.disabled {
		opacity: 0.5;
	}

	.vdpTimeControls {
		padding: 1.2em 2em;
		position: relative;
		margin: 1em -1em -1em;
		text-align: center;
		background: #f4f2f2;
	}

	.vdpTimeUnit {
		display: inline-block;
		position: relative;
		vertical-align: middle;
	}

	.vdpTimeUnit > input,
	.vdpTimeUnit > pre {
		font-size: 1.7em;
		line-height: 1.3;
		padding: 0.1em;
		word-wrap: break-word;
		white-space: pre-wrap;
		resize: none;
		margin: 0;
		box-sizing: border-box;
		color: #4c5e67;
		border: 0;
		border-bottom: 1px solid transparent;
		text-align: center;
	}

	.vdpTimeUnit > pre {
		visibility: hidden;
		font-family: inherit;
	}

	.vdpTimeUnit > input {
		position: absolute;
		top: 0;
		left: 0;
		overflow: hidden;
		height: 100%;
		width: 100%;
		outline: none;
		padding: 0;
		border-radius: 0;
		background: transparent;
		-webkit-appearance: none;
		-moz-appearance: none;
		appearance: none;
	}

	.vdpTimeUnit > input:focus,
	.vdpTimeUnit > input:hover {
		border-bottom-color: #dcdddf;
	}

	.vdpTimeUnit > input::-webkit-inner-spin-button,
	.vdpTimeUnit > input::-webkit-outer-spin-button {
		margin: 0;
		-webkit-appearance: none;
	}

	.vdpTimeCaption,
	.vdpTimeSeparator {
		display: inline-block;
		vertical-align: middle;
		font-size: 1.3em;
		color: #959fa4;
	}

	.vdpTimeCaption {
		margin-right: 0.5em;
	}
</style>
